import styled from "styled-components"

import { ApiTypes } from "types"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"

const SectionContent = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;
`

const ActionItem = styled.div`
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-subtle);
  }
`

const ActionTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 4px;
`

const ActionDescription = styled.p`
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.6;
`

const SummaryText = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0 0 8px;
  line-height: 1.6;
`

const LoadingText = styled.p`
  font-size: 14px;
  color: var(--text-disabled);
  margin: 0;
  padding: 8px 0;
`

const formatActionTitle = (actionId: string): string => actionId.replace(/_/g, " ").replace(/^\w/, c => c.toUpperCase())

interface Props {
  isLoading: boolean
  actions: ApiTypes.Model.IntelligenceReportDetailAction[] | undefined
}

export const RecommendedActionsSection = ({ isLoading, actions }: Props) => (
  <>
    <ModalSectionTitle title="Recommended Actions" />
    <SectionContent>
      {isLoading ? (
        <LoadingText>Loading...</LoadingText>
      ) : actions && actions.length > 0 ? (
        actions.map((action, index) => (
          <ActionItem key={index}>
            <ActionTitle>{formatActionTitle(action.action)}</ActionTitle>
            <ActionDescription>{action.description}</ActionDescription>
          </ActionItem>
        ))
      ) : (
        <SummaryText>No recommended actions.</SummaryText>
      )}
    </SectionContent>
  </>
)
